import { Canvg } from 'canvg';
import { parse } from 'svg-parser';

const SCALE_FACTOR = 3;

export async function getRasterImageFromSvg(illustrationFile, canvas) {
    if (!canvas) {
        throw new Error('Canvas provided is null');
    }
    const svgString = await readFileAsString(illustrationFile);
    const canvasContext = canvas.getContext('2d');
    const dimensions = getDimensionsFromSvg(svgString);
    const scaledDimensions = getScaledDimensionsFromScaleFactor(
        SCALE_FACTOR,
        dimensions.width,
        dimensions.height
    );
    // Use canvg
    const canvg = Canvg.fromString(canvasContext, svgString);
    canvg.resize(
        scaledDimensions.width,
        scaledDimensions.height,
        'xMidYMid meet'
    );
    canvg.start();

    const blob = await getCanvasBlob(canvas);
    return blob;
}

export async function readFileAsString(file) {
    const fileReader = new FileReader();
    return new Promise((resolve, reject) => {
        fileReader.onerror = function () {
            fileReader.abort();
            reject(new DOMException('Problem parsing input file'));
        };
        fileReader.onloadend = function (event) {
            resolve(fileReader.result);
        };
        fileReader.readAsText(file);
    });
}

function getCanvasBlob(canvas) {
    return new Promise(function (resolve, reject) {
        if (!canvas) {
            reject(new Error('Canvas provided is null'));
        }
        canvas.toBlob((blob) => resolve(blob), 'image/png', 1);
    });
}

export const getDimensionsFromSvg = (svgString) => {
    const parsedSvg = parse(svgString);
    return {
        width: parseInt(parsedSvg.children[0].properties.width),
        height: parseInt(parsedSvg.children[0].properties.height),
    };
};

const getScaledDimensionsFromScaleFactor = (
    scaleFactor,
    originalWidth,
    originalHeight
) => {
    return {
        width: scaleFactor * originalWidth,
        height: scaleFactor * originalHeight,
    };
};

export async function downloadSvgAndConvertToFile(url, name) {
    const response = await fetch(url);
    const blob = await response.blob();
    return new File([blob], `${name}.svg`, { type: 'image/svg+xml' });
}
